<template>
  <main class="bg_gray pattern">

    <div class="container margin_60_40">
      <div class="row justify-content-center">
        <div class="col-lg-4">
          <div class="box_booking_2">
<!--            <div class="head">-->
<!--              <div class="title">-->
<!--                <h3>Pizzeria da Alfredo</h3>-->
<!--                27 Old Gloucester St, 4530 - <a href="https://www.google.com/maps/dir//Assistance+%E2%80%93+H%C3%B4pitaux+De+Paris,+3+Avenue+Victoria,+75004+Paris,+Francia/@48.8606548,2.3348734,14z/data=!4m15!1m6!3m5!1s0x47e66e1de36f4147:0xb6615b4092e0351f!2sAssistance+Publique+-+H%C3%B4pitaux+de+Paris+(AP-HP)+-+Si%C3%A8ge!8m2!3d48.8568376!4d2.3504305!4m7!1m0!1m5!1m1!1s0x47e67031f8c20147:0xa6a9af76b1e2d899!2m2!1d2.3504327!2d48.8568361" target="blank">Get directions</a>-->
<!--              </div>-->
<!--            </div>-->
            <!-- /head -->
            <div class="main">
              <div id="confirm">
                <div class="icon icon--order-success svg add_bottom_15">
                  <img style="width: 40%;" src="/static/images/order-fail.png" alt="">
                </div>
                <h3>Không thành công !</h3>
                <p>Có lỗi xảy ra , vui lòng thử lại !</p>
                <router-link to="/cart" class="btn_1">Quay lại</router-link>
              </div>
            </div>
          </div>
          <!-- /box_booking -->
        </div>
        <!-- /col -->
      </div>
      <!-- /row -->
    </div>
    <!-- /container -->

  </main>
</template>

<script>
export default {
  name: "OrderFail"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/OrderFail.vue